var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: {
        id: "modal",
        value: _vm.visible,
        persistent: _vm.persistent,
        "max-width": _vm.fullscreen ? "100%" : _vm.maxWidth,
        "content-class": "v-card",
      },
      on: {
        "click:outside": function ($event) {
          return _vm.$emit("close-modal")
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _vm._t("default", function () {
        return [_vm._v(" Default Modal ")]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }